import React from 'react';
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {deleteProject} from "../../Projects/_redux/projectsActions";
import can from "../components/Permissions/can";
import CommonPopup from "../components/CommonPopup";

export function DeleteProjectColumnFormatter(cellContent, dispatch, intl) {
  const handleDeleteProject = (id) => {
    dispatch(deleteProject(id));
  };
  const disabledCondition = !can('full', 'projectsPage');
  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
  ${disabledCondition ? `custom-disabled-button cursor-default` : ``}`;

  return (
    <CommonPopup
      buttonOpenPopupLabel={
        <img
          src={toAbsoluteUrl("/media/svg/Cross_brandColor.svg")}
          alt="icon"
        />
      }
      buttonOpenPopupClassName={buttonClassName}
      disabled={disabledCondition}
      onConfirm={() => handleDeleteProject(cellContent)}
      header={intl.formatMessage({
        id: 'projects-popup-header-are-you-sure',
        defaultMessage: 'Are you sure you want to delete the project?'
      })}
    />
  )
}
